import costCenterService from "services/maintenance/costCenterService";
import { PointOfSaleOutlined } from "@mui/icons-material";
import MAINTENANCE_STORE_SELECTORS from "features/maintenance/dataStore/selectors";

const costCenterResource = {
    title: "Department",
    singular: "Departments",
    displayField: "division",
    pageIcon: PointOfSaleOutlined,
    setter: MAINTENANCE_STORE_SELECTORS.DEPARTMENT,

    service: costCenterService,

    columns: [
        {
            field: "constCenterCode",
            header: "Division Code",
            width: "15%"
        },
        {
            field: "division",
            header: "Division",
            width: "20%"
        },
        {
            field: "unit",
            header: "Division Unit",
            width: "20%"
        },
        {
            field: "description",
            header: "Office",
            width: "20%"
        },
        {
            field: "responsibilityCode",
            header: "Responsibility Code",
            width: "15%"
        },
        {
            field: "createdByName",
            header: "Created By",
            width: "10%"
        },
        {
            field: "updatedByName",
            header: "Updated By",
            width: "10%"
        }
    ],

    fields: [
        {
            name: "constCenterCode",
            label: "Division Code",
            type: "text",
            required: true,
            unique: true
        },
        {
            name: "division",
            label: "Division Unit",
            type: "text",
            required: true
        },
        {
            name: "unit",
            label: "Division Unit",
            type: "text",
            required: true
        },
        {
            name: "description",
            label: "Office",
            type: "text"
        },
        {
            name: "responsibilityCode",
            label: "Responsibility Code",
            type: "text"
        }
    ],
    searchFields: ["constCenterCode", "description"]
};

export default costCenterResource;
